export default __webpack_public_path__ + "static/media/phone.a6485283.svg";